import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const StyledInput = styled('input')`
  border: 0;
  border-bottom: ${props => props.invalid ? '2px solid #dc0228' : '0'};
  color: ${props => props.invalid ? '#dc0228' : '#888'};
  outline: none;
  font-size: 12px;
  padding: 0;
  &::after{
    content:'Invalid'
  }
`;

export default StyledInput;
